module.exports = __webpack_public_path__ + "static/home-depot-a164039a9974695512bd87474326db83.svg";